import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
  ListSuperAdminAuditLogsResponse,
  listSuperAdminAuditLogsContract
} from '@bliks-io/contracts';
import { apiClient } from '@/api/client';
import { auditLogKeys } from '@/api/query-keys';

export interface AuditLogFilters {
  tenantId?: string;
  entityType?: string;
  entityId?: string;
  actorId?: string;
  action?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export function useListSuperAdminAuditLogs(filters: AuditLogFilters = {}) {
  return useQuery({
    queryKey: auditLogKeys.list(filters),
    queryFn: async ({ signal }): Promise<ListSuperAdminAuditLogsResponse> => {
      const { data } = await apiClient.get<ListSuperAdminAuditLogsResponse>(
        listSuperAdminAuditLogsContract.path,
        { params: filters, signal }
      );
      return data;
    },
    placeholderData: keepPreviousData
  });
}
